import { handleWorkflow } from './actions/handleWorkflow';
import { handleJSCode } from './actions/handleJSCode';
import { handleHttpEndpoint } from './actions/handleHttpEndpoint';
import { handleUnknown } from './actions/handleUnknown';

/**
 * Centraliza o roteamento de ações para tipos conhecidos
 * @param {string} action
 * @param {object} formData
 * @param {object} config
 */
export async function runAction(action, formData, config, token = null) {
  if (!action || typeof action !== 'string') return;
  if (action.startsWith('wf:')) return handleWorkflow(action, formData, config);
  if (action.startsWith('jscode:')) return handleJSCode(action, formData, config, token);
  if (action.startsWith('http')) return handleHttpEndpoint(action, formData);
  
  return handleUnknown(action);
}
